var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGlobalservers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_18_2111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_18_2111)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2111)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12H12V36H36V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.79 32.76L33.07 32.04C33.44 31.48 33.66 30.8 33.66 30.08C33.66 28.1 32.06 26.5 30.08 26.5C28.1 26.5 26.5 28.1 26.5 30.08C26.5 32.06 28.1 33.66 30.08 33.66C30.81 33.66 31.48 33.44 32.04 33.07L32.76 33.79C32.9 33.93 33.09 34 33.27 34C33.46 34 33.64 33.93 33.78 33.79C34.07 33.5 34.07 33.04 33.79 32.76Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0298 26.6309C14.0298 26.6609 14.0098 26.7009 14.0098 26.7309C14.9298 28.5709 16.4298 30.0809 18.2698 30.9909C18.2998 30.9909 18.3398 30.9709 18.3698 30.9709C18.0298 29.8109 17.7698 28.6209 17.5798 27.4309C16.3798 27.2309 15.1898 26.9709 14.0298 26.6309Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0701 18.4295C30.1301 16.4595 28.5401 14.8695 26.5801 13.9395C26.9401 15.1295 27.2401 16.3495 27.4401 17.5695C28.6601 17.7695 29.8801 18.0595 31.0701 18.4295Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9297 18.4295C15.1297 18.0695 16.3497 17.7695 17.5697 17.5695C17.7697 16.3795 18.0197 15.1995 18.3597 14.0395C18.3297 14.0395 18.2897 14.0195 18.2597 14.0195C16.3797 14.9495 14.8497 16.5195 13.9297 18.4295Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8197 17.36C25.5797 16.06 25.2797 14.76 24.8497 13.5C24.8297 13.43 24.8297 13.37 24.8197 13.29C24.0797 13.11 23.2997 13 22.4997 13C21.6897 13 20.9197 13.11 20.1697 13.3C20.1597 13.37 20.1697 13.43 20.1497 13.51C19.7297 14.77 19.4197 16.06 19.1797 17.36C21.3897 17.12 23.6097 17.12 25.8197 17.36Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.36 19.1797C16.05 19.4197 14.77 19.7297 13.5 20.1497C13.43 20.1697 13.37 20.1697 13.3 20.1797C13.11 20.9197 13 21.6997 13 22.4997C13 23.3097 13.11 24.0797 13.3 24.8297C13.37 24.8397 13.43 24.8297 13.51 24.8497C14.77 25.2697 16.06 25.5797 17.37 25.8197C17.12 23.6097 17.12 21.3897 17.36 19.1797Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6999 20.1797C31.6299 20.1797 31.5699 20.1697 31.4899 20.1497C30.2299 19.7297 28.9299 19.4197 27.6299 19.1797C27.8799 21.3897 27.8799 23.6097 27.6299 25.8097C28.9299 25.5697 30.2299 25.2697 31.4899 24.8397C31.5599 24.8197 31.6199 24.8297 31.6999 24.8197C31.8799 24.0697 31.9999 23.2997 31.9999 22.4897C31.9999 21.6997 31.8899 20.9297 31.6999 20.1797Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1797 27.6409C19.4197 28.9509 19.7197 30.2409 20.1497 31.5009C20.1697 31.5709 20.1597 31.6309 20.1697 31.7109C20.9197 31.8909 21.6897 32.0009 22.4997 32.0009C23.2997 32.0009 24.0797 31.8909 24.8197 31.7009C24.8297 31.6309 24.8297 31.5709 24.8497 31.4909C25.2697 30.2309 25.5797 28.9409 25.8197 27.6309C24.7197 27.7509 23.6097 27.8409 22.4997 27.8409C21.3897 27.8409 20.2797 27.7609 19.1797 27.6409Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9506 18.9496C18.6506 21.3096 18.6506 23.6896 18.9506 26.0596C21.3106 26.3596 23.6906 26.3596 26.0606 26.0596C26.3606 23.6996 26.3606 21.3196 26.0606 18.9496C23.6906 18.6496 21.3106 18.6496 18.9506 18.9496Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2111",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2111",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobalservers);
export default __webpack_public_path__ + "static/media/icon-globalservers.64b7561b35c95f13e96e8135140791c8.svg";
export { ForwardRef as ReactComponent };